<template>
  <div class="error">
    <div class="error-background__icon">
      <img
        src="@/assets/images/auth/admin-background-icon.png"
        alt="background"
      />
    </div>
    <div class="card error-card text-center">
      <div class="card-body px-4 py-5 p-sm-5">
        <div class="error-code">404</div>
        <div class="error-title">糟糕! 找不到頁面</div>
        <p>
          很抱歉，您要查找的頁面未找到或不存在。嘗試刷新頁面或單擊下面的按鈕返回首頁。
        </p>
        <router-link
          class="btn btn-info rounded-pill mt-3 error-submit"
          :to="{ name: 'Website' }"
          >回首頁</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Error'
}
</script>

<style lang="scss">
.error {
  width: 100%;
  min-height: 100vh;
  overflow: hidden;
  background-color: #eef0f8;
  position: relative;
  &-background__icon {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    z-index: 1;
    img {
      width: 1600px;
      position: absolute;
      top: 80%;
      left: 50%;
      transform: translate(-50%, -100%);
    }
  }
  &-code {
    font-size: 100px;
    font-weight: bold;
    color: $info;
    font-family: "Roboto";
  }
  &-title {
    font-size: 46px;
    font-weight: bold;
  }
  &-card {
    width: 90%;
    max-width: 500px;
    border-radius: 10px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
    background-color: #fff;
    border: none;
  }
  &-submit {
    color: #fff;
    transition: box-shadow 0.3s ease-in-out;
    background: $linear-gradient;
    box-shadow: 0px 4px 4px $shadow-color;
    &:hover {
      color: #fff;
      box-shadow: 0px 7px 7px $shadow-color;
    }
  }
}
</style>
